const actionColumn = {
  alignHeader: 'center',
  alignColumns: 'center',
  key: 'actions',
  type: 'actions',
  width: 15,
};

export default actionColumn;
